/*
 *
 * OtpPopup
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 18-Jul-2025
*/

import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
// import { useFormik } from 'formik'
// import * as Yup from 'yup'
// import { useIntl } from 'react-intl'
// import { useMobileDetect } from 'Hoc/ListenerProvider'
import MerchantModal from '@nexidigital/merchantmodal'
// import MerchantFlowCard from '@nexidigital/merchantflowcard'
// import PortalOtp from '@nexidigital/portalotp'
// import PortalLink from '@nexidigital/portallink'
import './OtpPopup.scss'
import VerifyOtp from 'Components/VerifyOtp'

const OtpPopup = (props) => {
  const verifyOtpRef = useRef()

  useEffect(() => () => props.actions.doResetState(), [])

  return (
    <MerchantModal
      topBarTitle=' '
      title={formattedMessage.verifyIdentity}
      onClose={() => {
        if (props.onCloseFlag) {
          props.onClose()
        } else {
          props.actions.doHidePopup()
        }
      }}
      primaryAction={() => {
        if (verifyOtpRef.current && typeof verifyOtpRef.current.submitForm === 'function') {
          verifyOtpRef.current.submitForm()
        }
      }}
      primaryButtonLoading={props.isLoading}
      primaryButtonLabel={formattedMessage.confirm}
    >
      <div className='modalVerifyOtpContainer'>
        <VerifyOtp
          ref={verifyOtpRef}
          titleCard={props.title !== '' ? props.title : formattedMessage.cardTitle}
          subtitleCard={formattedMessage.cardSubTitle(props.maskedPhone)}
          maskedPhoneNumber={props.maskedPhone}
          errorData={props.errorData}
          labelPrimaryButton={formattedMessage.confirm}
          hidePrimaryButton
          actions={props.actions}
          isLoading={props.isLoading}
          disableAutoReset
        />
      </div>
    </MerchantModal>
  )
}

OtpPopup.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  actions: PropTypes.object,
  maskedPhone: PropTypes.string,
  errorData: PropTypes.object,
  onClose: PropTypes.func,
  onCloseFlag: PropTypes.bool
}

OtpPopup.defaultProps = {
  // Add here some default propTypes values
  title: PropTypes.string,
  isLoading: false,
  maskedPhone: '',
  actions: {},
  errorData: {},
  onClose: () => { },
  onCloseFlag: false
}

export default OtpPopup
